import { Flex, Form, InputNumber, message, Table, TableColumnsType } from 'antd'
import { CheckCircleFilled, CopyOutlined, LoadingOutlined, CloseCircleFilled, Loading3QuartersOutlined } from '@ant-design/icons';
import './index.less'
import CopyToClipboard from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import { formatNumber, strDot, toThousands, updateAddress } from '@/utils';
import MyIcon from '@/router/Icon';
import { motion } from 'framer-motion';
import { useEffect, useState, useMemo } from 'react';
import Loader from '@/components/Loader';
import { DataType } from '../../interface';
import { getSymbol } from '@/config/symbol';
import TransactionTag from '@/components/TransactionTag';
import { cdnUrl } from '@/utils/cdn';
import { isSuiCoinType } from '@/utils/suiMethods';

export default function WalletAddressTable({
  listLoading,
  progress,
  wallets,
  onImport,
  mintAddress,
  onSelectWallet,
  queryList,
  postAccountOverview,
  onDelWallet,
  handleWalletInputChange,
  form,
  queryListBalance,
  // symbol
  selectedTokenInfo,

  basicInfo
}: any) {

  const tokenAddress = useMemo(() => {
    return selectedTokenInfo?.address;
  }, [selectedTokenInfo]);
  const symbol = useMemo(() => {
    return selectedTokenInfo?.symbol;
  }, [selectedTokenInfo]);
  const { t } = useTranslation();
  const [queryLoading, setQueryLoading] = useState(false)


  function onCopy() {
    message.success(t("tips.copy"));
  }

  function onDel(key: any) {
    const newWallets = wallets.filter((item: any, idx: number) => item.key !== key);

    if (onDelWallet) {
      onDelWallet(newWallets);
    }
  }

  function switchStatus(row: any) {
    if (Number(row.status) === 0) {
      return <TransactionTag status={"noStart"} txt={t("batchTransfer.notExecuted")} />;
    }
    if (Number(row.status) === 1) {
      return <TransactionTag status={"loading"} txt="" />;
    }
    if (Number(row.status) === 2) {
      return <TransactionTag status={"success"} txt={t("batchTransfer.success")} hash={row.tx} onCopy={() => { onCopy() }} />;
    }

    if (Number(row.status) === 3) {
      return <TransactionTag status={"fail"} txt={row.msg} hash={row.tx} onCopy={() => { onCopy() }} />;
    }
  }

  function queryBalance(e: any) {
    e.preventDefault();
    queryListBalance && queryListBalance()
  }

  // useEffect(() => {
  //   console.log('WalletAddressTable wallets', wallets);
  // }, [wallets])

  const columns: TableColumnsType<DataType> = [
    {
      title: '#',
      dataIndex: 'key',
      key: 'key',
      align: 'center',
      width: 100,
      render: (_, record, index) => (
        <div className="custom-td">
          <p>{index + 1}</p>
        </div>
      )
    },
    {
      title: t("manyToMany.sendingAddress"),
      dataIndex: 'walletAddress',
      key: 'walletAddress',
      align: 'center',
      // width: "20%",
      render: (_, record) => (
        <CopyToClipboard text={`${record.walletAddress}`} onCopy={() => { onCopy() }}>
          <div className="custom-td" style={{ cursor: "pointer" }}>
            <p style={{ marginRight: '5px' }}>{strDot(record.walletAddress)}</p>
            <CopyOutlined />
          </div>
        </CopyToClipboard>
      )
    },
    {
      title: t("tokenBatchCollection.nativeTokenBalance", { symbol: basicInfo.symbol }),
      dataIndex: isSuiCoinType(basicInfo?.coinType) ? 'balance' : 'tokenBalance',
      key: isSuiCoinType(basicInfo?.coinType) ? 'balance' : 'tokenBalance',
      align: 'center',
      render: (_, record) => (
        <div className="custom-td">
          {queryLoading
            ?
            <Loader className="loader-spin-box"><img src={cdnUrl("/img/loading-grey.webp")} /></Loader>
            :
            <p>{`${formatNumber(isSuiCoinType(basicInfo?.coinType) ? record.balance : record.tokenBalance, 4)}`}</p>
          }
        </div>
      )
    },
    // {
    //   title: t("tokenBatchCollection.tokenBalance", { symbol }),
    //   dataIndex: 'tokenBalance',
    //   key: 'tokenBalance',
    //   align: 'center',
    //   render: (_, record) => (
    //     <div className="custom-td">
    //       {queryLoading
    //         ?
    //         <Loader className="loader-spin-box"><img src={cdnUrl("/img/loading-grey.webp")} /></Loader>
    //         :
    //         <p>{`${formatNumber(record.tokenBalance, 4)}`}</p>
    //       }
    //     </div>
    //   )
    // },
    {
      title: t("manyToMany.recipientAddress"),
      dataIndex: 'toAddress',
      key: 'toAddress',
      align: 'center',
      // width: "20%",
      render: (_, record) => (
        <CopyToClipboard text={`${record.toAddress}`} onCopy={() => { onCopy() }}>
          <div className="custom-td" style={{ cursor: "pointer" }}>
            <p style={{ marginRight: '5px' }}>{strDot(record.toAddress)}</p>
            <CopyOutlined />
          </div>
        </CopyToClipboard>
      )
    },
    {
      title: t("manyToMany.sendQuantity", { symbol: basicInfo.symbol }),
      dataIndex: 'opAmount',
      key: 'opAmount',
      align: 'center',
      render: (_, record) => (
        // <div className="custom-td">
        //   {queryLoading
        //     ?
        //     <Loader className="loader-spin-box"><img src={cdnUrl("/img/loading-grey.webp")} /></Loader>
        //     :
        //     <p>{`${formatNumber(record.balance, 4)}`}</p>
        //   }
        // </div>
        <div className="custom-td">
          <InputNumber
            style={{ width: '80%' }}
            value={formatNumber(record.opAmount, 4)}
            controls={false}
            min={0}
            max={record.balance}
            className='op-amount'
            disabled
          // onChange={(value: any) => {
          //   handleWalletInputChange(value, record.key)
          // }}
          />
        </div>
      )
    },
    {
      title: t("tokenBatchCollection.status"),
      key: 'status',
      align: 'center',
      render: (_, record) => (
        <div className="custom-td">{switchStatus(record)}</div>
      )
    },
    {
      title: t("tokenBatchCollection.operation"),
      key: 'operation',
      align: 'center',
      width: 100,
      render: (row: any) => (
        <div className="custom-td">
          <img style={{ cursor: "pointer" }} src={cdnUrl("/img/delete.svg")} onClick={() => onDel(row.key)} />
        </div>
      )
    },
  ];
  // return (<div className="wallet-address-table">
  //   <Table columns={columns} dataSource={wallets} scroll={{ y: 412 }} virtual pagination={false} />
  // </div>)
  return (
    <div className="table">
      {
        // listLoading ?
        //   (
        //     <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        //       {/* <Loader><img src={cdnUrl("/img/eth/loading-blue.webp")} alt="" /></Loader> */}
        //       {/* <LoadingOutlined /> */}
        //       <Loader>
        //         <img style={{ width: "20px" }} src={cdnUrl("/img/loading-grey.webp")} alt="" />
        //       </Loader>
        //       <span> {t("tokenBatchCollection.importing")} {progress.toFixed()}%</span>
        //     </div>
        //   ) : wallets.length === 0 ? (
        //     <Flex vertical justify="center" align="center" className="empty">
        //       <img src={cdnUrl("/img/empty.svg")} alt="" />
        //       <span>{t("tokenBatchCollection.importWalletPrivateKey")}</span>

        //     </Flex>
        //   ) :
        (
          <Table<DataType>
            virtual
            // rowSelection={rowSelection}
            // rowClassName={() => 'custom-row'}
            columns={columns}
            dataSource={wallets}
            pagination={false}
            scroll={{ y: 412 }}
            rowKey="key"
          />
        )
      }
    </div>
  )
}